import React from 'react'
import { useNavigate } from 'react-router-dom'
import { FaUser, FaTimes } from 'react-icons/fa'
import UserCard from './UserCard'

const FriendsTab = ({ friends, onRemove, loading }) => {
  const navigate = useNavigate()

  const handleRemove = (friendId, friendName) => {
    if (window.confirm(`Are you sure you want to remove ${friendName} from your friends?`)) {
      onRemove(friendId)
    }
  }

  return (
    <div>
      <h2 className="text-2xl font-semibold text-white mb-6">My Friends ({friends.length})</h2>

      <div className="space-y-4">
        {friends.map((friend) => (
          <UserCard
            key={friend._id}
            user={friend}
            subtitle={
              friend.friendsSince
                ? `Friends since ${new Date(friend.friendsSince).toLocaleDateString()}`
                : null
            }
            actions={
              <>
                <button
                  onClick={() => navigate(`/passport/${friend._id}`)}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-2 py-1.5 sm:px-4 sm:py-2 rounded-lg text-sm sm:text-base font-medium transition-colors flex items-center gap-1 sm:gap-2"
                >
                  <FaUser className="w-3 h-3 sm:w-4 sm:h-4" />
                  <span className="hidden sm:inline">View Passport</span>
                  <span className="sm:hidden">View</span>
                </button>
                <button
                  onClick={() => handleRemove(friend._id, friend.username)}
                  disabled={loading}
                  className="bg-red-600 hover:bg-red-700 disabled:bg-gray-600 text-white px-2 py-1.5 sm:px-4 sm:py-2 rounded-lg text-sm sm:text-base font-medium transition-colors flex items-center gap-1 sm:gap-2"
                >
                  <FaTimes className="w-3 h-3 sm:w-4 sm:h-4" />
                  <span className="hidden sm:inline">Remove</span>
                  <span className="sm:hidden">×</span>
                </button>
              </>
            }
          />
        ))}

        {friends.length === 0 && (
          <div className="text-center py-8">
            <p className="text-gray-400">No friends yet. Start by searching for people to connect with!</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default FriendsTab